import React, { useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Main from '../layouts/Main';
import { useApi } from '../contexts/Api';
import CampaignList from '../components/CampaignList';
import AddCampaignDialog from '../components/AddCampaignDialog';
import EditCampaignDialog from '../components/EditCampaignDialog';

const Campaigns = () => {
  const { campaigns, loadingCampaigns, fetchCampaigns } = useApi();
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const handleAddClick = () => {
    setAddDialogOpen(true);
  };

  const handleEditClick = (campaign) => {
    setSelectedCampaign(campaign);
    setEditDialogOpen(true);
  };

  const handleCloseDialogs = () => {
    setAddDialogOpen(false);
    setEditDialogOpen(false);
    setSelectedCampaign(null);
  };

  const handleAddSave = async () => {
    console.log('handleAddSave called');
    setAddDialogOpen(false);
    await fetchCampaigns();
  };

  const handleEditSave = async () => {
    console.log('handleEditSave called');
    setEditDialogOpen(false);
    setSelectedCampaign(null);
    await fetchCampaigns();
  };

  return (
    <Main>
      <div className="page-header">
        <div>
          <h1 className="page-title">Campaigns</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Campaigns</li>
          </ol>
        </div>
        <div className="page-header-actions">
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            sx={{ 
              backgroundColor: '#845adf',
              '&:hover': {
                backgroundColor: '#6c48c5'
              }
            }}
          >
            Add Campaign
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card custom-card">
            <div className="card-header">
              <div className="card-title">All Campaigns</div>
            </div>
            <div className="card-body">
              {loadingCampaigns ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                  <CircularProgress />
                </Box>
              ) : campaigns && campaigns.length > 0 ? (
                <CampaignList
                  campaigns={campaigns}
                  onEdit={handleEditClick}
                  onRefresh={fetchCampaigns}
                />
              ) : (
                <Box textAlign="center" py={5}>
                  <Typography variant="h6" color="text.secondary">
                    No campaigns found. Create your first campaign!
                  </Typography>
                </Box>
              )}
            </div>
          </div>
        </div>
      </div>

      <AddCampaignDialog
        open={addDialogOpen}
        onClose={handleCloseDialogs}
        onSave={handleAddSave}
      />

      <EditCampaignDialog
        open={editDialogOpen}
        onClose={handleCloseDialogs}
        campaign={selectedCampaign}
        onSave={handleEditSave}
      />
    </Main>
  );
};

export default Campaigns;